export default {
  workingYears: '/clientEcosys/courierLevel/workingYears'
}
